"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "ModalFooter", {
    enumerable: true,
    get: function() {
        return ModalFooter;
    }
});
const _style = /*#__PURE__*/ _interop_require_default(require("styled-jsx/style"));
const _react = /*#__PURE__*/ _interop_require_wildcard(require("react"));
const _Theme = require("../../../contexts/Theme");
const _ModalContext = require("../ModalContext");
function _interop_require_default(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function _getRequireWildcardCache(nodeInterop) {
    if (typeof WeakMap !== "function") return null;
    var cacheBabelInterop = new WeakMap();
    var cacheNodeInterop = new WeakMap();
    return (_getRequireWildcardCache = function(nodeInterop) {
        return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
    })(nodeInterop);
}
function _interop_require_wildcard(obj, nodeInterop) {
    if (!nodeInterop && obj && obj.__esModule) {
        return obj;
    }
    if (obj === null || typeof obj !== "object" && typeof obj !== "function") {
        return {
            default: obj
        };
    }
    var cache = _getRequireWildcardCache(nodeInterop);
    if (cache && cache.has(obj)) {
        return cache.get(obj);
    }
    var newObj = {
        __proto__: null
    };
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var key in obj){
        if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
            var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
            if (desc && (desc.get || desc.set)) {
                Object.defineProperty(newObj, key, desc);
            } else {
                newObj[key] = obj[key];
            }
        }
    }
    newObj.default = obj;
    if (cache) {
        cache.set(obj, newObj);
    }
    return newObj;
}
const ModalFooter = (param)=>{
    let { children, ref, hideBreakline = false } = param;
    const { stickyFooter, scrollable } = (0, _react.useContext)(_ModalContext.ModalContext);
    const { isAdmin } = (0, _Theme.useTheme)();
    let classes = "";
    let styles = {};
    if (isAdmin) {
        classes = scrollable && stickyFooter ? "sticky py-5 px-6" : "p-6";
    } else {
        styles = {
            padding: stickyFooter ? "0.75rem 1.5rem" : "1.5rem"
        };
    }
    return /*#__PURE__*/ _react.default.createElement("div", {
        ref: ref,
        style: {
            ...styles,
            zIndex: 1
        },
        className: _style.default.dynamic([
            [
                "a51cd629b6c4ed11",
                [
                    hideBreakline ? undefined : "0 -1px 0 0 rgba(0, 0, 0, 0.1)"
                ]
            ]
        ]) + " " + "".concat(classes, " footer")
    }, children, /*#__PURE__*/ _react.default.createElement(_style.default, {
        id: "a51cd629b6c4ed11",
        dynamic: [
            hideBreakline ? undefined : "0 -1px 0 0 rgba(0, 0, 0, 0.1)"
        ]
    }, "div.__jsx-style-dynamic-selector{display:-webkit-box;display:-webkit-flex;display:-moz-box;display:-ms-flexbox;display:flex;-webkit-box-pack:end;-webkit-justify-content:flex-end;-moz-box-pack:end;-ms-flex-pack:end;justify-content:flex-end;-webkit-transition:all 300ms!important;-moz-transition:all 300ms!important;-o-transition:all 300ms!important;transition:all 300ms!important}.sticky.__jsx-style-dynamic-selector{-webkit-box-shadow:".concat(hideBreakline ? undefined : "0 -1px 0 0 rgba(0, 0, 0, 0.1)", ";-moz-box-shadow:").concat(hideBreakline ? undefined : "0 -1px 0 0 rgba(0, 0, 0, 0.1)", ";box-shadow:").concat(hideBreakline ? undefined : "0 -1px 0 0 rgba(0, 0, 0, 0.1)", "}")));
};

//# sourceMappingURL=ModalFooter.js.map